/** Represents the strategy to use for converting date objects to strings. */
export enum BarDateTimeConversionStrategy{
    /** Converts the date to an iso string with the exact same date. */
    Iso,
    /** Converts the date to an iso string in GMT 0. */
    IsoGmt
}